import { useEffect, useState } from "react";

type CustomVideoElem = HTMLVideoElement & {
    mozHasAudio?: boolean;
    webkitAudioDecodedByteCount?: number;
    audioTracks?: unknown[];
};
/**
 * @param video Video element but we have to opt out of type safety because we're using non-standard dom apis
 * Copied from https://stackoverflow.com/questions/21270048/html5-video-how-to-detect-when-there-is-no-audio-track
 */
function _hasAudio(video: CustomVideoElem): boolean {
    return (
        video.mozHasAudio ||
        Boolean(video.webkitAudioDecodedByteCount) ||
        Boolean(video.audioTracks && video.audioTracks.length)
    );
}

export function useDetectAudio(
    videoRef: React.RefObject<HTMLVideoElement | null>,
    src: unknown,
) {
    const [hasAudio, setHasAudio] = useState(false);
    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;
        setHasAudio(_hasAudio(video));
        function detectAudio() {
            if (!video) return;
            setHasAudio(_hasAudio(video));
        }
        video.addEventListener("loadeddata", detectAudio);
        video.addEventListener("loadedmetadata", detectAudio);
        return () => {
            video.removeEventListener("loadeddata", detectAudio);
            video.removeEventListener("loadedmetadata", detectAudio);
        };
    }, [src]);
    return hasAudio;
}
